<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>国际运费配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="24" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-blue" @click="addConfig"
                >新增</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>

      <div slot="table" class="full-height display-col">
        <el-form :rules="rules" label-width="80px">
          <el-table :header-cell-style="tableStyle.headerStyle"
                    :cell-style="tableStyle.cellStyle" :data="configList"   height="550">
            <el-table-column align="center" type="weight" label="重量" >
              <template slot-scope="scope">
                <div>
                  <!-- <el-form-item  prop="endWeight"> -->
                  <span ><el-input type="number" v-model="scope.row.startWeight" style='width:80px;margin-right: 15px' disabled  prop="startWeight"></el-input>&lt;a</span>
                  <span v-if="scope.row.sortFlag !=99" >≤ <el-input type="number" v-model='scope.row.endWeight' style='width:80px ;margin-left: 15px'
                            @input='monitor(scope.row)' /></span>
                            <!-- </el-form-item> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="chargingMethod" label="收费方式" >
              <template slot-scope="scope">
                <div>
                  <div v-if='scope.row.type==1'>固定值：<el-input type="number" v-model='scope.row.firstPrice' style='width:60px '  size="small"/></div>
                  <div v-if='scope.row.type==2'>首重：<el-input type="number" v-model='scope.row.firstWeight' style='width:60px '  size="small"/>
                                                  首重价格：<el-input type="number" v-model='scope.row.firstPrice' style='width:60px '  size="small"/>
                                                  超过的单价：<el-input type="number" v-model='scope.row.excessPrice' style='width:60px '  size="small"/>/
                                                        <el-input type="number" v-model='scope.row.excessWeight' style='width:60px '  size="small"/></div>
                </div>
                <div v-if='scope.row.type==3'>单价：<el-input type="number" v-model='scope.row.firstPrice' style='width:60px ' size="small" />  </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作" >
              <template slot-scope="scope">
                <el-button
                  class="list-btn btn-deepblue"
                  @click="editConfig(scope.row)"
                  >编辑</el-button
                >
                <div v-if="scope.row.sortFlag!=1&&scope.row.sortFlag!=99">
                  <el-button
                  class="list-btn btn-warn"
                  @click="delConfig(scope.row)"
                  >删除</el-button
                >
                </div>

              </template>
            </el-table-column>
          </el-table>
              <div style="text-align:center">
                <el-button class="form-btn btn-blue" @click="SubmitSave" >提交</el-button>
              </div>
        </el-form>

      </div>
    </table-con>
    <el-dialog
      title="收费方式"
      :visible.sync="dialogVisible"
      width="50%"
      @close="ConfigDialogClose"
    >
      <el-form
        :model="editFrom"
        label-width="120px"
        class="add-role-form"
        ref="editFrom"
      >
        <el-form-item label="配置方式：">
          <el-radio-group v-model="editFrom.type">
              <el-radio  label="1">固定总值</el-radio>
              <el-radio  label="2">区间值（首重)</el-radio>
              <el-radio  label="3">单价</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="editFrom.type ==1">
          <el-form-item label="固定值：">
            <el-input
              v-model="editFrom.firstPrice"
              size="small"
              style="width: 100px"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="editFrom.type ==2">
          <el-form-item >
           首重：<el-input type="number" v-model='editFrom.firstWeight' style='width:60px '  />
           首重价格：<el-input type="number" v-model='editFrom.firstPrice' style='width:60px '  />
           超过的单价：<el-input type="number" v-model='editFrom.excessPrice' style='width:60px '  />
            <el-input type="number" v-model='editFrom.excessWeight' style='width:60px '  />
          </el-form-item>
        </div>
        <div v-if="editFrom.type ==3">
          <el-form-item label="单价：">
            <el-input
              v-model="editFrom.firstPrice"
              size="small"
              style="width: 100px"
            ></el-input>
          </el-form-item>
        </div>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeAccessoriesDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmEdit">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 新增配置 -->
    <el-dialog
      title="收费方式"
      :visible.sync="dialogVisibleAdd"
      width="50%"
      @close="ConfigAddClose"
    >
      <el-form
        :model="addFrom"
        label-width="120px"
        class="add-role-form"
        ref="addFrom"
      >
        <el-form-item label="">
          <span ><el-input type="number" v-model="addFrom.startWeight" style='width:80px;margin-right: 15px' disabled  prop="startWeight" ></el-input>&lt;a</span>
                  <span>≤ <el-input type="number" v-model='addFrom.endWeight' style='width:80px ;margin-left: 15px'
                            @blur="blur" /></span>
        </el-form-item>
        <el-form-item label="配置方式：">
          <el-radio-group v-model="addFrom.type">
              <el-radio  label="1">固定总值</el-radio>
              <el-radio  label="2">区间值（首重)</el-radio>
              <el-radio  label="3">单价</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="addFrom.type ==1">
          <el-form-item label="固定值：">
            <el-input
              v-model="addFrom.firstPrice"
              size="small"
              style="width: 100px"
              type="number"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="addFrom.type ==2">
          <el-form-item >
           首重：<el-input type="number" v-model='addFrom.firstWeight' style='width:60px '  />
           首重价格：<el-input type="number" v-model='addFrom.firstPrice' style='width:60px '  />
           超过的单价：<el-input type="number" v-model='addFrom.excessPrice' style='width:60px '  />
            <el-input type="number" v-model='addFrom.excessWeight' style='width:60px '  />
          </el-form-item>
        </div>
        <div v-if="addFrom.type ==3">
          <el-form-item label="单价：">
            <el-input
              v-model="addFrom.firstPrice"
              size="small"
              style="width: 100px"
              type="number"
            ></el-input>
          </el-form-item>
        </div>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeAdd">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmAddCheck">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增时价格弹框提示 -->
    <el-dialog
      title="提示"
      :visible.sync="addTips"
      width="20%"
      @close="addTipsClose"
    >
    <p>不能小于{{addFrom.startWeight}}</p>
    <!-- <el-button type="primary" @click="confirmEdit">确 定</el-button> -->
    </el-dialog>

    <!-- 新增时不为空弹框提示 -->
    <el-dialog
      title="提示"
      :visible.sync="editTips"
      width="20%"
      @close="editTipsClose"
    >
    <p>重量或者价格不能为空，请填写后在提交</p>
    <!-- <el-button type="primary" @click="confirmEdit">确 定</el-button> -->
    </el-dialog>

    <!-- 提交保存时弹框提示 -->
    <el-dialog
      title="提示"
      :visible.sync="SubmitSaveTips"
      width="20%"
      @close="SubmitSaveTipsClose"
    >
    <p>重量大小配置顺序有误，请检查！</p>
    <!-- <el-button type="primary" @click="confirmEdit">确 定</el-button> -->
    </el-dialog>

  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  name: 'InternationalShipping',
  components: { tableCon },
  data() {
    // var compare = (rule, value, cb) => {
    //   return cb();
    // };
    return {
      rules:{
        endWeight:[
           { required: true, message: "请输入重量", trigger: "blur" },
            // { validator: compare, trigger: "blur" }
        ],


      } ,

      queryInfo: {
        userName: "",
        userId: "",
        pageSize: 15,
        pageNum: 1,
      },
      configWeight: {//重量接收
        id: 0,
        startWeight: 0,
        endWeight: 0,
        type: "",
        firstWeight: 0,
        firstPrice: 0,
        excessWeight: 0,
        excessPrice: 0,
        sortFlag:"",
      },
      editFrom:{
        type:'2',
        startWeight:'',
        endWeight:'',
        firstWeight:'',
        firstPrice:'',
        excessWeight:'',
        excessPrice:'',
        subscript:''//下标
      },
      //增加的
      addFrom:{
        type:'2',
        startWeight:'',
        endWeight:'',
        firstWeight:'',
        firstPrice:'',
        excessWeight:'',
        excessPrice:'',
        subscript:''//下标
      },
      configList: [],
      // total: 0,
      dialogVisible: false,
      dialogVisibleAdd:false,
      addTips:false,
      editTips:false,
      SubmitSaveTips:false,
      numTips:0,
    };
  },
  methods: {
    confirmAdd() {
      let index =  this.configList.length;
      let lastData =  this.configList[index-1];
      this.configList.splice(index-1,1)
      this.configList.push(this.addFrom);
      this.configList.push(lastData);
      this.configList[this.configList.length-1].startWeight = this.addFrom.endWeight;
      this.SubmitSave();
      this.dialogVisibleAdd = false;
    },
    //新增时 为空校验
    confirmAddCheck(){
      let check = false;
      console.log(this.addFrom.endWeight.length)
      if(this.addFrom.endWeight.length==0){
          check =true;
      }
      if(this.addFrom.type==1){
        if(this.addFrom.firstPrice.length==0||this.addFrom.firstPrice==null){
          check =true;
        }
      }else if(this.addFrom.type==2){
        if(this.addFrom.firstWeight.length==0|| this.addFrom.firstPrice.length==0||this.addFrom.excessPrice.length==0||this.addFrom.excessWeight.length==0||this.addFrom.excessWeight==null
        ||this.addFrom.firstWeight==null|| this.addFrom.firstPrice==null||this.addFrom.excessPrice==null){
          check =true;
        }
      }else{
        if(this.addFrom.firstPrice.length==0||this.addFrom.firstPrice==null){
          check =true;
        }
      }

      if(this.configList.length>=7){
        this.$message.error('最多可添加7个重量区间，请重新操作！');
      }else{
        console.log(check)
        if(check){
          this.editTips= true;
        }else{
          this.confirmAdd();
        }
      }


    },

    closeAdd(){
        this.dialogVisibleAdd = false;
    },
    ConfigAddClose(){
      this.dialogVisibleAdd = false;
    },
    addConfig(){
      this.addFrom.startWeight = this.configList[this.configList.length-2].endWeight;
      this.dialogVisibleAdd =true;

    },
    addTipsClose(){
      this.addTips = false;
    },
    editTipsClose(){
      this.editTips = false;
    },
    SubmitSaveTipsClose(){
      this.SubmitSaveTips = false;
    },
    //新增校验
    blur(val){
      if(new Number(this.addFrom.startWeight)>=new Number(this.addFrom.endWeight)){
        this.addTips = true
        this.addFrom.endWeight = null;
      }
    },
    //编辑校验
    editCheck(val){
      if(this.configList.indexOf(val)+2!=this.configList.length){
        if(val.endWeight > this.configList[this.configList.indexOf(val)+1].endWeight){
          this.numTips = this.configList[this.configList.indexOf(val)+1].endWeight;
          this.editTips = true;
          this.configList[this.configList.indexOf(val)].endWeight = null;
          this.monitor(val)
        }
      }
    },
    //输入时 监控
    monitor(val){
      var index = this.configList.indexOf(val);
      this.configList[index+1].startWeight = val.endWeight
    },
    //编辑配置
    editConfig(row){
      this.dialogVisible=true
      this.editFrom =JSON.parse(JSON.stringify(row));
      this.editFrom.subscript = this.configList.indexOf(row)
    },
    //保存编辑配置
    confirmEdit(){
      this.$set(this.configList, this.editFrom.subscript, this.editFrom);
      this.dialogVisible=false;
    },
    //删除选中的
    delConfig(row){
      //删除的下标
      let num =  this.configList.indexOf(row);
      this.configList[num+1].startWeight = this.configList[num-1].endWeight;
      this.configList[num].delFlag = 1;
      console.log(this.configList)
      this.SubmitSave();
    },

    async SubmitSave(){
      let check = false;
      this.configList.forEach(item=>{
          if(item.startWeight >=item.endWeight){
            if(item.sortFlag!=99){
              console.log(item)
              check =true;
              return;
            }
          }
      })
      if(check){
        this.SubmitSaveTips = true;
      }else{
        const { data: res } = await this.$http.post("InternationalShippingConfig/editInternationalShippingConfig",
        {"listJson":JSON.stringify(this.configList)});

        if(res.code ==2500){
          this.$message.error(res.message);
        }
        this.getconfigList()
      }

    },
    //失去焦点
    onInputBlur(rule, value, callback){
          if(value == null ){
            thisStyle(new Error('请输入重量'));
          }else if(value !=''  ){
            thisStyle(new Error('该用户名已经存在，请重新输入'));
          }else{
            callback();
          }

    },
    async getconfigList() {
      const { data: res } = await this.$http.post("InternationalShippingConfig/getAllInternationalShippingConfig");
      console.log(res);
      this.configList = res.data;
    },

    closeAccessoriesDialog(){
      this.dialogVisible =false;
      this.init();
    },
    ConfigDialogClose(){
      this.dialogVisible = false;
      this.init();
      },
    init(){
      this.editFrom ={
        type:'2',
        startWeight:'',
        endWeight:'',
        firstWeight:'',
        firstPrice:'',
        excessWeight:'',
        excessPrice:''
      }
    }
  },

  created() {
    this.getconfigList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
